import { LEDGER_SNAPSHOT_EXTENTION, } from "@frameworks/web/redux/interfaces/Reports/ILedgerSnapShot";
import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
const initState = {
    snapShotExtention: [],
};
const snapShotExtentionReducer = (state = initState, action) => {
    switch (action.type) {
        case LEDGER_SNAPSHOT_EXTENTION:
            return Object.assign(Object.assign({}, state), { snapShotExtention: action.payload.snapShotExtention });
        default:
            return Object.assign({}, state);
    }
};
export default combineReducers({
    reducersData: snapShotExtentionReducer,
    commonData: commonOnePlatFormReducer,
});
